import React from "react";
import { Box } from "@mui/material";
import { useMyHrChangeRequestsBadges } from "my-hr/hooks";
import { OcSidebarBadge } from "oc/components/sidebar-badge";
import { useOcCurrentUserState } from "oc/hooks";

export const MyHrMenuBadges = () => {
  let { contractCode } = useOcCurrentUserState();
  const { data: value } = useMyHrChangeRequestsBadges(contractCode);
  if (!value) return null;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <OcSidebarBadge id="myHrMenuBadge" value={value} urgent />
    </Box>
  );
};
